import { Grid } from "@mui/material";
import { PropsWithChildren } from "react";

export const FormWrapper = (props: PropsWithChildren) => {
    return <Grid container justifyContent="center" >
        <Grid item xs={12} sm={8} md={6} xl={6}>
            {props.children}
        </Grid>
    </Grid>
}